"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gilroy = void 0;
var Gilroy_Bold_woff_1 = __importDefault(require("../assets/fonts/Gilroy-Bold.woff"));
var Gilroy_Medium_woff_1 = __importDefault(require("../assets/fonts/Gilroy-Medium.woff"));
var Gilroy_Regular_woff_1 = __importDefault(require("../assets/fonts/Gilroy-Regular.woff"));
var Gilroy_SemiBold_otf_1 = __importDefault(require("../assets/fonts/Gilroy-SemiBold.otf"));
var Gilroy_Bold_woff_2 = __importDefault(require("../assets/fonts/v2/Gilroy-Bold.woff"));
var Gilroy_ExtraBold_woff_1 = __importDefault(require("../assets/fonts/v2/Gilroy-ExtraBold.woff"));
var Gilroy_Medium_woff_2 = __importDefault(require("../assets/fonts/v2/Gilroy-Medium.woff"));
var Gilroy_MediumItalic_woff_1 = __importDefault(require("../assets/fonts/v2/Gilroy-MediumItalic.woff"));
var Gilroy_Regular_woff_2 = __importDefault(require("../assets/fonts/v2/Gilroy-Regular.woff"));
var Gilroy_SemiBold_otf_2 = __importDefault(require("../assets/fonts/v2/Gilroy-SemiBold.otf"));
var Gilroy_SemiBoldItalic_woff_1 = __importDefault(require("../assets/fonts/v2/Gilroy-SemiBoldItalic.woff"));
exports.gilroy = [
    {
        fontFamily: "Gilroy",
        fontWeight: 600,
        src: "url(" + Gilroy_Bold_woff_1.default + ") format('woff')",
    },
    {
        fontFamily: "Gilroy",
        fontWeight: 500,
        src: "url(" + Gilroy_SemiBold_otf_1.default + ") format('opentype')",
    },
    {
        fontFamily: "Gilroy",
        fontWeight: 400,
        src: "url(" + Gilroy_Medium_woff_1.default + ") format('woff')",
    },
    {
        fontFamily: "Gilroy",
        fontWeight: 300,
        src: "url(" + Gilroy_Regular_woff_1.default + ") format('woff')",
    },
    {
        fontFamily: "Gilroy-Regular-v2",
        src: "url(" + Gilroy_Regular_woff_2.default + ") format('woff')",
    },
    {
        fontFamily: "Gilroy-Bold-v2",
        src: "url(" + Gilroy_Bold_woff_2.default + ") format('woff')",
    },
    {
        fontFamily: "Gilroy-SemiBold-v2",
        src: "url(" + Gilroy_SemiBold_otf_2.default + ") format('opentype')",
    },
    {
        fontFamily: "Gilroy-MediumItalic-v2",
        src: "url(" + Gilroy_MediumItalic_woff_1.default + ") format('woff')",
    },
    {
        fontFamily: "Gilroy-ExtraBold-v2",
        src: "url(" + Gilroy_ExtraBold_woff_1.default + ") format('truetype')",
    },
    {
        fontFamily: "Gilroy-SemiBoldItalic-v2",
        src: "url(" + Gilroy_SemiBoldItalic_woff_1.default + ") format('truetype')",
    },
    {
        fontFamily: "Gilroy-Medium-v2",
        src: "url(" + Gilroy_Medium_woff_2.default + ") format('woff')",
    },
];
